(function () {
  "use strict";
  var root = document.documentElement;
  if (!root.classList.contains('mh-intro-run')) return;

  var overlay = document.querySelector('.mh-intro');
  if (!overlay) { root.classList.remove('mh-intro-run'); return; }

  var done = false;

  // Idempotent teardown. Every path below leads here, including the watchdog,
  // so there is no sequence of events that can leave the curtain up.
  function end() {
    if (done) return;
    done = true;
    root.classList.remove('mh-intro-run');
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    off();
  }

  // Any sign of impatience skips it. A visitor who taps, scrolls, presses a
  // key or hits Back should not be made to wait out an animation.
  var EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
  function skip() { end(); }
  function off() {
    EVENTS.forEach(function (e) { window.removeEventListener(e, skip); });
    overlay.removeEventListener('animationend', onAnim);
  }
  EVENTS.forEach(function (e) {
    window.addEventListener(e, skip, { passive: true, once: true });
  });

  function onAnim(e) {
    // Only the curtain finishing counts; the inner beats fire this too.
    if (e.target === overlay) end();
  }
  overlay.addEventListener('animationend', onAnim);

  // Last line of defence. If the animation never fires - a background tab, a
  // paused renderer, an engine that dislikes something above - the shop is
  // still there a moment later.
  setTimeout(end, 3400);

  // Restoring from the back/forward cache would otherwise show a frozen
  // curtain over the page.
  window.addEventListener('pageshow', function (e) { if (e.persisted) end(); });
})();
